export class PaginatorModel {
    constructor(
        public first: number = 0,
        public page: number = 0,
        public pageCount: number = 0,
        public rows: number = 0
    ) { }
}
